export class SurveyModel {
  displayType: string | "horizontal" | "vertical" | "grid" = "horizontal";
  tabIndex: number = 0;
  image?: any;
  question?: string = "";
  choices?: any[] = [];
  comments?: { question: string; comments: any[] }[] = [];

  constructor(survey?: SurveyModel) {
    this.image =
      survey && survey.image
        ? survey.image
        : {
            file: null,
            src: null,
            isExpand: false,
          };
    this.question = survey && survey.question ? survey.question : "";
    this.choices =
      survey && survey.choices && survey.choices.length !== 0
        ? survey.choices
        : [
            {
              label: "Choice 1",
              image: {
                file: null,
                src: null,
                isExpand: false,
              },
            },
            {
              label: "Choice 2",
              image: {
                file: null,
                src: null,
                isExpand: false,
              },
            },
          ];

    this.comments = Array.from({ length: 4 }, () => ({
      question: "",
      comments: Array.from({ length: 4 }, () => ({ value: "" })), // Corrected syntax for creating objects
    }));

    if (survey && survey.comments && survey.comments.length !== 0) {
      survey.comments.forEach(
        (comment, index) => (this.comments[index] = comment)
      );
    }
  }
}
